// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"jr-z","imageAndVideoCount":"kr-z","imageAndVideoContainer":"lr-z","viewAllReviews":"mr-z"};